export default {
  isHomePlayer: (state, getters, rootState) => rootState.common.userDetails.msisdn === state.playersDetails.homePlayerMSISDN,
  isCurrentRoundWinner: (state, getters, rootState) => rootState.common.userDetails.msisdn === state.currentRoundWinnerMSISDN
                                                    && rootState.common.userDetails.username === state.currentRoundWinnerUsername,
  isFinalRound: state => state.currentRoundNumber === state.finalRoundNumber,
  isGameWinner: (state, getters, rootState) => rootState.common.userDetails.msisdn === state.gameWinnerMSISDN
                                            && rootState.common.userDetails.username === state.gameWinnerUsername,
};



// WEBPACK FOOTER //
// ./src/store/modules/game/getters.js